import type { KeywordContext } from "@app/types/Page";
import CampaignTemplateBudget from "@pages/Keyword/templates/CampaignTemplate/CampaignTemplateBudget";
import { CampaignTemplateKeywordContext } from "@pages/Keyword/templates/CampaignTemplate/types";
import TemplateKeywordDefault from "@pages/Keyword/templates/TemplateKeywordDefault/TemplateKeywordDefault";
import TemplateWithHighlights from "@pages/Keyword/templates/TemplateWithHighlights/TemplateWithHighlights";
import { isCampaignTemplateBudgetData } from "@pages/Keyword/utils/helpers";

type TemplateFactoryProps = {
  data: KeywordContext["data"] | CampaignTemplateKeywordContext["data"];
};

export default function TemplateFactory({ data }: TemplateFactoryProps) {
  const { template } = data;

  if (isCampaignTemplateBudgetData(data)) {
    return <CampaignTemplateBudget data={data} />;
  }

  if (template === "withHighlight") {
    return <TemplateWithHighlights data={data} />;
  }

  return <TemplateKeywordDefault data={data} />;
}
